import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NotificationState {
  message: string | null;
  severity: "success" | "error" | "warning" | "info";
}

const initialState: NotificationState = {
  message: null,
  severity: "warning",
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    showSessionExpired: (state) => {
      state.message = "Session expired. Please log in again.";
      state.severity = "warning";
    },
    clearNotification: (state) => {
      state.message = null;
    },
  },
});

export const { showSessionExpired, clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
